import { call, put, takeEvery } from "redux-saga/effects";
import AXIOS_INSTANCE from "../../utils/USOBConfig";


import {
  areasLoading,
  submitAreasActionDispatcher,
  submitAreasErrorDispatcher,
  SUBMIT_AREAS_ACTION_REQUESTED,
} from "./Action"; // Path should come here

const postAreasAPI = async (postData) => {
  const result = await AXIOS_INSTANCE.get("/areas", { params: postData });
  return result;
};

function* submitAreasSaga({ postData }) {
  try {
    yield put(areasLoading(true));
    const data = yield call(postAreasAPI, postData);
    yield put(submitAreasActionDispatcher(data));
    yield put(submitAreasErrorDispatcher({}));
    yield put(areasLoading(false));
  } catch (e) {
    yield put(submitAreasActionDispatcher({}));
    yield put(submitAreasErrorDispatcher(e.response.data));
    yield put(areasLoading(false));
  }
}

function* submitAreasWatcher() {
  yield takeEvery(SUBMIT_AREAS_ACTION_REQUESTED, submitAreasSaga);
}
export default submitAreasWatcher;
